// lib/timer/timer.tsx
import {
  useEffect,
  useRef,
  useState,
  useCallback
} from "react";
import { Fragment, jsx } from "react/jsx-runtime";
var TIMER_TICK_INTERVAL_MS = 60 * 1e3;
function useStateAndRef(initial) {
  const [value, setValue] = useState(initial);
  const valueRef = useRef(value);
  valueRef.current = value;
  return [value, setValue, valueRef];
}
var ThemeChangeTimer = ({
  name = "default",
  every,
  onNextAlarmArmed,
  onAlarm,
  tickIntervalMs = TIMER_TICK_INTERVAL_MS
}) => {
  const [, setAlarmTime, alarmTimeRef] = useStateAndRef();
  const rearm = useCallback(() => {
    const alarmTime = alarmTimeRef.current;
    const now = /* @__PURE__ */ new Date();
    if (alarmTime === void 0 || now > alarmTime) {
      const nextAlarm = /* @__PURE__ */ new Date();
      nextAlarm.setHours(every.hour);
      nextAlarm.setMinutes(every.minute);
      nextAlarm.setSeconds(every.second);
      console.debug(`[${name}]`, "Now is", now);
      if (now > nextAlarm) {
        console.debug(`[${name}]`, "Next alarm is", nextAlarm);
        console.debug(`[${name}]`, "Too late for today. Try tomorrow");
        nextAlarm.setDate(nextAlarm.getDate() + 1);
      }
      console.debug(`[${name}]`, "Arming for (not before)", nextAlarm);
      setAlarmTime(nextAlarm);
      if (onNextAlarmArmed !== void 0) {
        onNextAlarmArmed(nextAlarm);
      }
    }
  }, [
    alarmTimeRef,
    every.hour,
    every.minute,
    every.second,
    name,
    onNextAlarmArmed,
    setAlarmTime
  ]);
  useEffect(rearm, [rearm]);
  useEffect(() => {
    const timer = setInterval(() => {
      const now = /* @__PURE__ */ new Date();
      const alarmTime = alarmTimeRef.current;
      if (alarmTime !== void 0 && now > alarmTime) {
        onAlarm(now);
        rearm();
      }
    }, tickIntervalMs);
    return () => {
      clearInterval(timer);
    };
  }, [alarmTimeRef, onAlarm, rearm, tickIntervalMs]);
  return /* @__PURE__ */ jsx(Fragment, {});
};

export {
  ThemeChangeTimer
};
